// hooks/useAgentChat.js
import { useState } from "react";
import { sendAgentMessageApi } from "../services/agentService";


export function useAgentChat({ workspaceId, token }) {
    const [messages, setMessages] = useState([
        { from: "agent", text: "Hi! Ich bin dein virtueller Familien-Assistent. Wie kann ich dir helfen?" }
      ]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);


    const sendMessage = async (text) => {
        const userMessage = { from: "user", text };
        setMessages((prev) => [...prev, userMessage]);
        setLoading(true);
        setError(null);


        try {
            const response = await sendAgentMessageApi({
                workspaceId,
                token,
                message: text,
            });

            // assuming backend returns: { reply: "..." }
            const agentMessage = {
                from: "agent",
                text: response.reply,
            };

            setMessages((prev) => [...prev, agentMessage]);
        } catch (err) {
            setError("Failed to get agent response");
            setMessages((prev) => [
                ...prev,
                { from: "agent", text: "Sorry, something went wrong." },
            ]);
        } finally {
            setLoading(false);
        }
    };


    return {
        messages,
        sendMessage,
        loading,
        error,
        setMessages,
    };
}